import { useMemo } from 'react';
import { useCatalogContext } from '../../state/Catalog';

export const useLineageTitles = () => {
  const { selectedCategory } = useCatalogContext();
  return useMemo(() => {
    const lineageTitles = [];
    const lineage = selectedCategory?.lineageCsp;
    if (lineage) {
      const department = lineage[1];
      if (department) {
        lineageTitles.push({ slash: false, category: department });
      }
      const category = lineage[2];
      if (category) {
        lineageTitles.push({ slash: true, category: category });
      }
      if (selectedCategory) {
        lineageTitles.push({
          slash: false,
          category: { title: selectedCategory.title },
        });
      }
    }
    return lineageTitles;
  }, [selectedCategory]);
};
